<template>
  <div>
    <div class="loader" v-if="payments.length == 0 && !isPaid"></div>
    <div class="base-group" v-if="payments.length > 0 || isPaid">
      <div v-if="isPaid">Monthly Prive has already been paid</div>
      <div v-if="!isPaid">
        <h2 style="text-align:center;">{{ today }}</h2>
        <div class="content-group">
          <div class="label">Current Balance</div>
          <div class="content">{{ balance }}</div>
        </div>
        <div class="content-group">
          <div class="label">Monthly Income</div>
          <div class="content">{{ income }}</div>
        </div>
        <div class="content-group">
          <div class="label">Amount to withdraw</div>
          <input class="content" style="width:150px;" type="number" v-model="amount">
        </div>
        <table v-if="totalTransfer.length > 0">
          <col style="width:10%">
          <col style="width:30%">
          <col style="width:20%">
          <col style="width:30%">
          <thead>
            <tr><th>Pegawai</th><th>Prive</th><th>Reimburse</th><th>Total</th></tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in totalTransfer" :key="index">
              <td style="text-transform:capitalize;">{{item.name}}</td>
              <td class="align-right">{{item.prive}}</td>
              <td class="align-right">{{item.reimbursement}}</td>
              <td class="align-right">{{item.total}}</td>
            </tr>
          </tbody>
        </table>
        <dig-button @click.native="ProcessPayment" style="margin-top:10px;width:100px;" type="button-info" text="Process" :isLoading="isPaying"></dig-button>
      </div>
    </div>
    <dig-notif :text="notif.text" :show.sync="notif.show"></dig-notif>
  </div>
</template>

<script>
import Notif from '../digilib_web/vue/notif.vue'
import Button from '../digilib_web/vue/button.vue'
import { Http } from '../digilib_web/core/digitify.js'
import moment from 'moment'

export default {
  methods: {
    OnShow: function() {
      Http.Request(
        'GET', 'prive/monthly',
        {
          OnResponse:function(json) {
            if (json) {
              this.balance = parseInt(json.balance).toLocaleString();
              this.income = parseInt(json.income).toLocaleString();
              this.payments = json.payments;
            } else {
              this.isPaid = true;
            }
          }.bind(this)
        }
      );
    },
    ProcessPayment: function() {
      if (this.amount == 0) {
        alert('Amount to withdraw needs to be more than 0');
        return;
      }
      if (this.isPaying) { return; }
      this.isPaying = true;
      Http.Request(
        'POST', 'prive/process',
        {
          data: {amount: this.amount},
          OnResponse:function(json) {
            this.isPaying = false;
            if (json.success) {
              this.notif.show = true;
              this.notif.text = 'Successfully paid!';
              this.isPaid = true;
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    }
  },
  components: {
    'dig-button': Button,
    'dig-notif': Notif,
  },
  mounted() {
    this.OnShow();
    var today = moment();
    this.today = today.format('MMMM YYYY');
    this.months.data = moment.monthsShort();
    var curYear = today.year();
    this.years.selected = curYear;
    this.years.data.push(curYear);
  },
  data() {
		return {
      balance: 0,
      income: 0,
      amount: 0,
      payments: [],
      today: {},
      tab: {
        selected: 0,
        items: [
          {title:'History', icon:'fa fa-database'},
          {title:'Monthly', icon:'fa fa-plus'}
        ],
      },
      isPaid: false,
      isPaying: false,
      months: {data: [], selected: ''},
      years: {data: [], selected: ''},
      notif: {text:'', show:false}
		}
  },
  computed: {
    totalTransfer: function() {
      var transfer = [];
      for (var i = 0; i < this.payments.length; ++i) {
        this.payments[i].prive = this.amount * (i == 0 ? 0.6 : 0.4);
        this.payments[i].total = (this.payments[i].prive + this.payments[i].reimbursement).toLocaleString();
        transfer.push(this.payments[i]);
      }
      return transfer;
    }
  }
}
</script>

<style scoped>
.label {
  flex: 1;
}
.content {
  text-align: right;
}
.base-group {
  display:flex;
  flex-flow: column;
}
.content-group {
  display:flex;
  padding:10px 0 10px 0;
}
</style>
